import type {
  FeatureFlagKey,
  FeatureFlagRegistry,
} from "../../model/feature-flag.model";

export function useFeatureFlagStore() {
  const innerState = useState<FeatureFlagRegistry>(
    "feature_flags",
    () => ({}) as FeatureFlagRegistry,
  );

  return {
    flags: readonly(innerState),
    set: (state: FeatureFlagRegistry) => {
      innerState.value = state;
    },
  };
}

function toRegexp(emailRestrictionItem: string) {
  return new RegExp(
    emailRestrictionItem.replaceAll(".", String.raw`\.`).replaceAll("*", ".*"),
  );
}

export function useFeatureFlag(key: FeatureFlagKey) {
  const { flags } = useFeatureFlagStore();
  const { me } = useCurrentUser();

  const flag = flags.value[key];

  if (!flag?.enabled) return false;

  const restrictedToEmails = flag.emails;

  if (!restrictedToEmails?.length) return true;

  return restrictedToEmails.some((email) =>
    toRegexp(email).test(me.value?.email ?? ""),
  );
}
